import { useMutation, useQuery } from '@tanstack/react-query';
import * as recipientConnectionService from 'services/recipientConnection';
import { CustomNotification } from 'common/components';
import { getPartyInfo } from 'services/product';

export const useMutateCheckRecipientRequirement = () => {
  return useMutation({
    mutationFn: async ({ params, targetType }) => {
      const response =
        await recipientConnectionService.checkRecipientPublishRequirement(
          params
        );

      const { isSuccess, message } = response;

      if (isSuccess) {
        return Promise.resolve(true);
      } else {
        //* if target recipient is always Walmart show all messages
        if (targetType === 'walmart' && message) {
          CustomNotification.error(message || 'Server Error');
        }

        return Promise.resolve(false);
      }
    },
  });
};

export const useQueryPartyInfo = ({
  searchText,
  pageIndex,
  pageSize,
  recipientType,
  enabled = true,
}) => {
  return useQuery({
    queryKey: ['partyList', searchText, pageIndex, pageSize, recipientType],
    queryFn: async () => {
      const params = {
        filters: [],
        pageIndex,
        pageSize,
        search: { searchText },
        sort: [{ fieldName: 'id', isAscending: false }],
      };

      if (recipientType) {
        params.recipientType = recipientType;
      }

      const response = await getPartyInfo(params);

      const { data, isSuccess, message } = response || {};

      if (isSuccess) {
        return {
          gridData: data?.gridData ?? [],
          paging: data?.paging ?? {},
        };
      } else {
        const error = message || 'Server Error';
        CustomNotification.error(error);
        Promise.reject(error);
      }
    },
    enabled,
  });
};
